import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoRadAprovarPreFatura({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'radaprovarprefaturaaprovar', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoRadAprovarPreFatura({ payload }) {
  try {
    const { fatu_codigo, params } = payload;

    yield call(api.delete, `radaprovarprefaturaaprovar/${fatu_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoradaprovarprefatura, params } = payload;

    yield call(
      api.post,
      'radaprovarprefaturaaprovar',
      operacaoradaprovarprefatura
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/radaprovarprefatura');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { fatu_codigo } = payload;

    const { data } = yield call(
      api.get,
      `radaprovarprefaturaaprovar/${fatu_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoradaprovarprefatura, params } = payload;

    yield call(
      api.put,
      'radaprovarprefaturaaprovar',
      operacaoradaprovarprefatura
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/radaprovarprefatura');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'radaprovarprefaturaaprovar', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoradaprovarprefatura/RADAPROVARPREFATURA_IN_REQUEST',
    requestOperacaoRadAprovarPreFatura
  ),
  takeLatest(
    '@operacaoradaprovarprefatura/DELETE_RADAPROVARPREFATURA',
    deleteOperacaoRadAprovarPreFatura
  ),
  takeLatest(
    '@operacaoradaprovarprefatura/SUCCESS_REMOVE',
    requestOperacaoRadAprovarPreFatura
  ),
  takeLatest('@operacaoradaprovarprefatura/STORE_RADAPROVARPREFATURA', store),
  takeLatest('@operacaoradaprovarprefatura/FIND_RADAPROVARPREFATURA', find),
  takeLatest('@operacaoradaprovarprefatura/UPDATE_RADAPROVARPREFATURA', update),
  takeLatest('@operacaoradaprovarprefatura/RECORD_FILTERING', applyedFilters),
]);
